// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","basketBarHeight":"4rem","actionBarHeight":"3.5rem","bootstrap":"Gb9121a G6c4e2c","pageContainer":"Gc48c8b","pullUp":"G68b22e","withBottomBar":"Ge2d681"};